import { TypedPorcentagem } from '@acme/common'
import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Empresa } from './empresas'
import { Funcionario, FuncionarioCentroCusto } from './funcionario'
import { RegraCalculoPresenter } from './regras-calculo'

export const CreateImplantacaoSchema = zod.SaldoHorasSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    saldoAnteriorId: true,
    implantacao: true,
    funcionarioId: true,
    empresaId: true,
}).partial({
    porcentagemHorasExtras: true,
})

export type SaldoHoras = z.infer<typeof zod.SaldoHorasSchema> & {
    Funcionario?: Funcionario
    Empresa?: Empresa
}

export type SaldoHorasPorcentagens = {
    Funcionario?: {
        nome: string
        FuncionarioCentroCusto?: FuncionarioCentroCusto[]
        RegrasCalculo: RegraCalculoPresenter
    }
    CentrosCusto?: Array<{
        id: number
        nomeCentroCusto: string
    }>
    CentroCusto?: {
        id: number
        nomeCentroCusto: string
    }
    empresaId: number
    funcionarioId?: number
    tipoControle: string
    id: string
    /** Compensadas */
    horasExtras: string
    faltas: string
    porcentagemHorasExtras: TypedPorcentagem
    porcentagensCompesacao: TypedPorcentagem
    porcentagensPagamento: TypedPorcentagem
    totalCompensacao: string
    saldoAnterior?: string
    SaldoEspelho: SaldoHoras
    pagamentoTotal: string
    pagamentoFaltas: string
    saldo: string
    implantado?: boolean
}

export type SaldoHorasDiario = {
    id: string
    empresaId: number
    funcionarioId: number
    data: string
    competencia: string
    horasExtras: string
    faltas: string
    extras: string
    saldoDia: string
    acumuladoMes: string
    acumuladoBanco: string
    pagamento: string
    totalPagamentoCompetencia: string
    porcentagemHorasExtras: TypedPorcentagem
    tipoControle: string
    funcionarioNome?: string
    _funcionarioNome?: string
    Funcionario?: {
        id?: number
        nome?: string
        tipoControle?: string
        FuncionarioCentroCusto?: FuncionarioCentroCusto[]
    }
    FuncionarioCentroCusto?: FuncionarioCentroCusto[]
    centroCustoId?: number
    centroCustoNome?: string
    _centroCustoId?: number
    _centroCustoNome?: string
}

export const saldoHoras = new ApiService<Omit<SaldoHoras, '__typename'>>(
    'saldo-horas',
)
export const saldoHorasV2 = new ApiService<
    SaldoHorasPorcentagens | SaldoHorasDiario
>('saldo-horas', 'v2')
